<template>
  <div class="app-container">
    <app-icon
      class="app-icon"
      :name="name"
      :src="src"
      :name-display="false"
      @clickAppIcon="clickAppIcon()">
    </app-icon>
    <div class="app-info">
      <div class="app-name">
        {{name}}
      </div>
      <div class="url-container">
        <a 
          :href="googlePlay"
          target="_blank">
          <v-icon
            v-if="!isEmptyGooglePlay"
            name="brands/google-play"
            scale="2"/>
        </a>
        <a
          :href="appStore"
          target="_blank">
          <v-icon
            v-if="!isEmptyAppstore"
            name="brands/apple"
            scale="2.2"/>
        </a>
        <a
          :href="windows"
          target="_blank">
          <v-icon
            v-if="!isEmptyWindows"
            name="brands/windows"
            scale="2.3"/>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import AppIcon from '@/components/AppIcon.vue'

export default {
  name: 'AppCard',
  data: () => {
    return {
    }
  },
  props: {
    name: String,
    src: String,
    explain: String,
    appStore: String,
    googlePlay: String,
    windows: String
  },
  computed: {
    isEmptyAppstore() {
      return !this.appStore || this.appStore.length == 0;
    },
    isEmptyGooglePlay() {
      return !this.googlePlay || this.googlePlay.length == 0;
    },
    isEmptyWindows() {
      return !this.windows || this.windows.length == 0;
    }
  },
  methods: {
    clickAppIcon() {
      this.$emit("clickAppIcon")
    }
  },
  components: {
    AppIcon
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.app-icon {
  flex-grow: 0;
}
.app-info {
  flex-basis: 25%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-width: 180px;
}
.app-name {
  padding: 2px 8px;
  border-radius: 8px;
  color: #2f2f2f;
  border-radius: 8px;
  margin: 0px 0px 8px 0px;
  font-size: 1.1rem;
  font-weight: bold;
}
.url-container {
  display: flex;
  justify-content: center; 
  align-items: center;
}
.url-container svg {
  margin: 5px 10px;
  fill: #2f2f2f;
  transition-duration: 0.2s;
}
.url-container svg:hover {
  fill: #7b7b7b;
}
.app-container {
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 5px;
}
@media screen and (max-width: 700px) {
  .app-name {
    font-size: 0.8rem;
  }
}
@media screen and (max-width: 380px) {
  .app-container {
    flex-direction: column;
  }
}
</style>
